module.exports = "/fonts/opensansextrabolditalic.woff2";